import {
    ChannelGroup,
    ChannelGroupsFilterDtoIn,
    ChannelGroupInfo,
    CopyChannelGroup
} from "@/services/channels/types";
import api from "@/services/api";

export async function getFilteredChannelGroups(model: ChannelGroupsFilterDtoIn): Promise<ChannelGroup[]> {
    return new Promise((resolve, reject) => {
        api.post("/channelGroups/filter", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getAllChannelGroups(): Promise<Array<ChannelGroup>> {
    return new Promise((resolve, reject) => {
        api.get("/channelGroups").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getChannelGroupById(id: string): Promise<ChannelGroup> {
    return new Promise((resolve, reject) => {
        api.get("/channelGroups/" + id).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getChannelGroupInfo(id: string): Promise<ChannelGroupInfo> {
    return new Promise((resolve, reject) => {
        api.get(`/channelGroups/info/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function createChannelGroup(channel: ChannelGroup): Promise<string> {
    return new Promise((resolve, reject) => {
        api.post("/channelGroups", channel).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function updateChannelGroup(channel: ChannelGroup): Promise<void> {
    return new Promise((resolve, reject) => {
        api.put("/channelGroups", channel).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function copyChannelGroup(channelGroup: CopyChannelGroup): Promise<void> {
    return new Promise((resolve, reject) => {
        api.post("/channelGroups/copy/", channelGroup).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function checkDelete(id: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        api.get(`/channelGroups/delete/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function deleteChannelGroup(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
        api.delete(`/channelGroups/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
